import { AllocationRuleDto, CarrierVisitDirection } from '@yard/app/api'
import { AllocationRuleStore } from '@yard/stores/allocation-rule.store'
import { CapacitySettingsStore } from '@yard/stores/CapacitySettingsStore'
import { JourneyStore } from '@yard/stores/journey.store'
import { OccupancyStore } from '@yard/stores/OccupancyStore'
import { YardBlockStore } from '@yard/stores/YardBlockStore'
import { makeObservable } from 'mobx'
import { BaseAllocationRulesViewStore } from './base-allocation-rules.view-store'

export class GlobalAllocationRulesViewStore extends BaseAllocationRulesViewStore {
  constructor(
    allocationRuleStore: AllocationRuleStore,
    occupancyStore: OccupancyStore,
    journeyStore: JourneyStore,
    yardBlockStore: YardBlockStore,
    capacitySettingsStore: CapacitySettingsStore,
  ) {
    super(
      allocationRuleStore,
      occupancyStore,
      journeyStore,
      yardBlockStore,
      capacitySettingsStore,
    )
    makeObservable(this, {})
  }

  resetChanges() {
    this.setAllocationRules(this.allocationRuleStore.globalRules)
    super.resetChanges()
  }

  async submitRules() {
    await Promise.all(
      this.deletedRulesIds.map(id => this.allocationRuleStore.deleteGlobalAllocationRule(id)),
    )

    const storeRulesById = this.allocationRuleStore.globalRules.reduce<
      Record<string, AllocationRuleDto>
    >((acc, rule) => {
      acc[rule.id] = rule
      return acc
    }, {})

    await Promise.all(
      this.allocationRules
        .filter(
          (rule, index) =>
            !rule.id ||
            this.editedRulesIds.includes(rule.id) ||
            storeRulesById[rule.id]?.priority !== index,
        )
        .map(rule => this.allocationRuleStore.upsertAllocationRuleByAllocationRuleDto(rule)),
    )

    this.resetChanges()
  }

  copyTemplateRule(templateRule: AllocationRuleDto) {
    const templateRuleForGlobalRule = {
      ...templateRule,
      facets: { ...templateRule.facets, direction: CarrierVisitDirection.Outbound },
    }

    super.copyTemplateRule(templateRuleForGlobalRule)
  }
}
